import { render, staticRenderFns } from "./HorizontalTabMenuHeaderGroup.vue?vue&type=template&id=627a8458&"
import script from "./HorizontalTabMenuHeaderGroup.vue?vue&type=script&lang=js&"
export * from "./HorizontalTabMenuHeaderGroup.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTabMenuHeaderGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItemGroup,VMenu})
